import React from "react";
import { UltraFilter } from "~/components/ultra-filter";
import { ActiveFilter, FilterProvider } from "~/components/ultra-filter/types";
import { useDateProvider } from "~/filterProviders/useDateProvider";
import { useTextProvider } from "~/filterProviders/useTextProvider";
import { useWorkLocationProvider } from "~/filterProviders/useWorkLocationProvider";
import { TrainingReportFilterOptions } from "./types";

export type FilterFormProps = {
  onFiltersChanged: React.Dispatch<TrainingReportFilterOptions>;
};

export const FilterForm: React.FC<FilterFormProps> = ({ onFiltersChanged }) => {
  const providers = [
    useDateProvider({
      documentationText: "Show training entries after this date.",
      type: "after",
      label: "After",
      suggestText: "after",
    }),
    useDateProvider({
      documentationText: "Show training entries before this date.",
      type: "before",
      label: "Before",
      suggestText: "before",
    }),
    useTextProvider({
      documentationText: "Search by employee name.",
      type: "employeeSearch",
      label: "Employee",
      suggestText: "emp",
      toParam: (filter: ActiveFilter) => filter?.value ?? "",
    }),
    useTextProvider({
      documentationText: "Filter by training type.",
      type: "trainingType",
      label: "Training Type",
      suggestText: "type",
      toParam: (filter: ActiveFilter) => filter?.value ?? "",
    }),
    useWorkLocationProvider({
      documentationText: "Filter by the employee's work location.",
    }),
  ] as FilterProvider[];

  const onChanged = (filters: ActiveFilter[]) => {
    const afterFilter = filters.find((f) => f.type === "after");
    const beforeFilter = filters.find((f) => f.type === "before");

    const newFilters: TrainingReportFilterOptions = {
      after: afterFilter?.value?.format("YYYY-MM-DD") || null,
      before: beforeFilter?.value?.format("YYYY-MM-DD") || null,
      employeeSearch:
        filters.find((f) => f.type === "employeeSearch")?.value || null,
      trainingType:
        filters.find((f) => f.type === "trainingType")?.value || null,
      workLocation:
        filters.find((f) => f.type === "workLocation")?.value || null,
    };

    onFiltersChanged(newFilters);
  };

  return (
    <div className="filter-form">
      <UltraFilter
        {...{
          providers,
          dialogTitle: "Training Report Filters",
          label: "Type to filter training records",
          onFiltersChanged: onChanged,
          ignoreSearchText: true,
        }}
      />
    </div>
  );
};
